<template src="./templates/details.html" />

<script type="text/ecmascript-6">
import { SubmissionObject } from 'src/pages/submissions/script/common.data'
import SubmissionComputed from 'src/pages/submissions/script/common.computed'
import SubmissionMethods from 'src/pages/submissions/script/common.methods'
import SubmissionLoading from 'src/pages/submissions/components/loading/'
import FouContainer from 'src/components/tools/fou-container/'
import FouExpand from 'src/components/tools/fou-expand/'
import FouGroup from 'src/components/layout/fou-group/'
import FouGrid from 'src/components/layout/fou-grid/'
import Preview from 'src/pages/submissions/components/preview/'
import MessageHistory from 'src/pages/submissions/components/message-history/'
import { TimeoutUtil } from 'src/utils/helper/timer'
import HomePageMethods from 'src/pages/home/script/common.methods'
import Channels from 'src/pages/submissions/components/channels/'
import { mapGetters } from 'vuex'
import FouPreview from '../../components/tools/fou-preview'

export default {
  name: 'SubmissionsDetails',

  components: {
    SubmissionLoading,
    FouContainer,
    FouExpand,
    FouGroup,
    ...FouGrid,
    Preview,
    MessageHistory,
    Channels,
    FouPreview
  },

  beforeRouteLeave(to, from, next) {
    SubmissionObject.readyComplete = false
    next()
  },

  data() {
    return {
      ...SubmissionObject,
      ready: {
        name: this.$options.name,
        state: 'unset'
      },
      posterTimer: TimeoutUtil(),
      timer: 15000,
      selected: String(this.getFormatFromRoute())
    }
  },

  computed: {
    ...SubmissionComputed,
    ...mapGetters('auth', ['hasRole']),
    submissionFormatsLength() {
      if (this.submission.userMetaData.hasOwnProperty('formats')) {
        return this.submission.userMetaData.formats.length > 1 || this.submission.userMetaData.formats.length === 0
      }
      return true
    },
    disableFormat() {
      if (this.submission.userMetaData.hasOwnProperty('formats')) {
        return this.submission.userMetaData.formats.length === 1 || this.submission.userMetaData.formats.length === 0
      }
      return true
    }
  },

  created() {
    this.resetSubmissionStore()
    this.$store.dispatch('profile/getFoundries')
    this
      .init()
      .then((response) => {
        this.updateGraphics()
        this.ready.state = 'set'
        this.$nextTick(() => {
          this.$events.$emit('fou:expand:update')
        })
        this.selected = this.selected === '0' ? null : this.selected
      })
  },
  beforeUnmount() {
    this.posterTimer.clear()
    this.$events.$off('get:images', this.posterTimer.clear())
    this.$events.$off('send:images', this.posterTimer.clear())
  },

  methods: {
    ...SubmissionMethods,
    ...HomePageMethods,
    init() {
      return new Promise(resolve => {
        this.$store.commit('submissions/setFormat', this.getFormatFromRoute())
        this
          .startSubmission()
          .then(() => {
            return this.$store.dispatch('binaries/getAll', {
              submissionId: this.submission.id
            })
          })
          .then(() => {
            this.ImageGetter()
            this.ImageSetter()
            resolve()
          })
      })
    },
    navigateToCorrect(submissionId) {
      this.$router.push({
        name: 'submissions_correct',
        params: {
          id: submissionId
        }
      })
    },
    navigateToLiveEdit(submissionId) {
      const formatId = this.getFormatFromRoute() === null ? 0 : this.getFormatFromRoute()
      this.resetSubmission().then(() => {
        SubmissionObject.readyComplete = false
      })
      this.$router.push({
        name: 'live_submissions_correct',
        params: {
          id: submissionId,
          format: formatId
        }
      })
    },
    isPackagePriceEmpty() {
      const singleStylePackage = this.submissionPackages.filter((item) => item.packageType === 'singleStyle')
      return singleStylePackage.some((val) => val.prices.length === 0)
    },
    updateGraphics() {
      this.$store.commit('graphics/clear')
      this.$events.$emit('get:images')
    },
    ImageGetter() {
      this.$events?.$on('get:images', () => {
        this.$store.dispatch('graphics/getAll', {
          submissionId: this.submission.id
        }).then((response) => {
          this.$events.$emit('send:images', response)
        })
      })
    },
    ImageSetter() {
      this.$events?.$on('send:images', (response) => {
        if (this.submission.isLive && response !== undefined) {
          const isPosterAvailable = response.collection.every((item) => {
            if (item.hasOwnProperty('versions')) {
              return item.resourceLocation !== '' && item.versions.length > 0 && item.versionsStatus === 'completed'
            } else {
              return item.resourceLocation !== '' && item.versionsStatus === 'completed'
            }
          })
          if (!isPosterAvailable) {
            this.posterTimer.set(() => {
              this.updateGraphics()
            }, this.timer)
          } else {
            this.posterTimer.clear()
            this.$events.$off('get:images', this.posterTimer.clear())
            this.$events.$off('send:images', this.posterTimer.clear())
          }
        }
      })
    },
    navigateToReview(selectedFormat) {
      this.showReview(Number(selectedFormat), this.submission.id)
    }
  },



}
</script>
<style src="./stylesheets/index.scss" lang="scss" module></style>
